//#region Angular Imports

import { StateProvider, StateService } from '@uirouter/angularjs'

//#endregion

import { Activity, Enums } from '../../models/common/'

import { default as apiModule, Api, LocalDictionaryFactory } from '../api/api.module'
import { default as commonModule, LoggerService } from '../common/common.module'

import { MenuItem } from '../common/sidebar-menu/common.sidebar-menu.directive'

import { ConfigHelper, IUserSession, UserSession } from '../../helpers'
import { OpOperator } from '../../models/core'

import { SERVICES_MODULE_NAME } from './../../services'
import { SYSTEM_SERVICE_PROVIDER_NAME, SystemServiceProvider, $SCOPE_SERVICE_NAME, $STATE_SERVICE_NAME, $TIMEOUT_SERVICE_NAME, SYSTEM_SERVICE_NAME, SystemService, $STATE_SERVICE_PROVIDER_NAME } from '../../services/system'

import { GRID_SERVICE_NAME, GridContextMenuService, GridService } from '../../services/grid'

import { USER_SESSION_SERVICE_NAME, USER_SESSION_SERVICE_PROVIDER_NAME } from '../../services/user-session'

//#region Asset Imports

import * as TEMPLATE from './configuration-profiles.tpl.html'
import { ConfigurationProfileController } from './configuration-profiles.controller'
import { CONFIGURATION_PROFILE_SERVICE_NAME, ConfigurationProfileService } from './../../services/configuration-profile'
import { ConfigurationProfileDetailsDirective } from './details/configuration-profile-details.directive'
import { ConfigurationProfileCreateEditDirective } from './create-edit/configuration-profile-create-edit.directive'
import { ConfigurationProfileScheduleComponent, COMPONENT_NAME as CONFIGURATION_PROFILE_SCHEDULE_COMPONENT_NAME } from './configuration-profile-schedule/configuration-profile-schedule.component'
import { ConfigurationProfileCreateEditPopupDirective } from './create-edit/create-edit-popup/configuration-profile-create-edit-popup.directive'

//#endregion

// #region Consts

const CONTROLLER_NAME: string = 'ConfigurationProfileController'
const CREATE_EDIT_DIRECTIVE_NAME: string = 'configurationProfileCreateEdit'
const CREATE_EDIT_POPUP_DIRECTIVE_NAME: string = 'configurationProfileCreateEditPopup'
const DETAILS_DIRECTIVE_NAME: string = 'configurationProfileDetails'
const MODULE_NAME: string = 'simax.configuration-profile'
const MODULE_NAME_LOCALIZATION_TEXT: string = 'CONFIGURATION_PROFILE_NAME'
const STATE_NAME: string = 'configurationProfile'
const STATE_URL: string = '/configurationProfile'

// #endregion


// #region Setup


const module = angular.module(MODULE_NAME, [commonModule, apiModule, SERVICES_MODULE_NAME])

module.controller(CONTROLLER_NAME, [
    $SCOPE_SERVICE_NAME, 
    $STATE_SERVICE_NAME, 
    $TIMEOUT_SERVICE_NAME, 
    'api', 
    'logger', 
    'localDictionary',
    USER_SESSION_SERVICE_NAME, 
    CONFIGURATION_PROFILE_SERVICE_NAME,
    GRID_SERVICE_NAME, 
    SYSTEM_SERVICE_NAME, 
(
    $scope,
    $state: StateService,
    $timeout: ng.ITimeoutService,
    api: Api,
    logger: LoggerService,
    localDictionary: LocalDictionaryFactory,
    userSession: IUserSession,
    configurationProfileService: ConfigurationProfileService,
    gridContextMenuService: GridContextMenuService,
    systemService: SystemService
) => new ConfigurationProfileController(
    $scope,
    $state,
    $timeout,
    api,
    logger,
    localDictionary,
    userSession,
    configurationProfileService,
    gridContextMenuService,
    systemService,
    Enums.ReferenceType.IdConfigurationProfile,
    Enums.SimaxModuleName.Configuration_Profile,
)])

module.directive(DETAILS_DIRECTIVE_NAME, [() => new ConfigurationProfileDetailsDirective()])
module.directive(CREATE_EDIT_DIRECTIVE_NAME, [() => new ConfigurationProfileCreateEditDirective()])
module.directive(CREATE_EDIT_POPUP_DIRECTIVE_NAME, [() => new ConfigurationProfileCreateEditPopupDirective()])

module.component(CONFIGURATION_PROFILE_SCHEDULE_COMPONENT_NAME, new ConfigurationProfileScheduleComponent())

module.config([$STATE_SERVICE_PROVIDER_NAME, USER_SESSION_SERVICE_PROVIDER_NAME, SYSTEM_SERVICE_PROVIDER_NAME, (
    $stateProvider: StateProvider,
    userSessionProvider: UserSession,
    systemServiceProvider: SystemServiceProvider
) => {

    systemServiceProvider.registerDetailsComponent({
        key: 'Configuration_Profile_IdConfigurationProfile',
        componentName: DETAILS_DIRECTIVE_NAME
    })

    userSessionProvider
        .getLoggedOperatorAsync()
        .then((loggedOperator: OpOperator) => {
            if (loggedOperator.hasPermission(Activity.CONFIGURATION_PROFILE_LIST)) {
                MenuItem.addMenuItem(
                    ConfigHelper.getIconName(ConfigHelper.Icon.MY_LIBRARY_BOOKS),
                    'configurationProfile',
                    MODULE_NAME_LOCALIZATION_TEXT,
                    STATE_NAME,
                    10
                )

                $stateProvider.state(STATE_NAME, {
                    url: STATE_URL,
                    controller: CONTROLLER_NAME,
                    controllerAs: '$ctrl',
                    template: TEMPLATE,
                    params: { ids: null }
                })
            }
        })
}])

export default MODULE_NAME

// #endregion